import {
	getLocalStorageItem,
	nameInUrlFormat,
	removeLocalStorageItem,
	setLocalStorageItem,
} from '../../services/Helper';
import { historyPush } from '../../services/History';

export const getUserToken = (code) => {
	if (!code) return null;
	const storedKeys = getLocalStorageItem('LIVE_BATTLE');
	const userToken =
		storedKeys &&
		JSON.parse(storedKeys).find((item) => item.code?.toString() === code?.toString());

	return userToken ? userToken.token : null;
};

export const setUserToken = (code, token) => {
	const storedKeys = getLocalStorageItem('LIVE_BATTLE');
	const tokenObj = { code, token };

	setLocalStorageItem(
		'LIVE_BATTLE',
		storedKeys
			? JSON.stringify([...JSON.parse(storedKeys), tokenObj])
			: JSON.stringify([tokenObj]),
	);
};

export const removeUserToken = (code) => {
	const storedKeys = getLocalStorageItem('LIVE_BATTLE');
	if (!storedKeys) return;

	if (JSON.parse(storedKeys).length === 1) {
		removeLocalStorageItem('LIVE_BATTLE');
		return;
	}

	const userToken = JSON.parse(storedKeys).find((item) => item.code === code);

	if (userToken) {
		const newTokensArray = JSON.stringify(
			JSON.parse(storedKeys).filter((item) => item.code !== code),
		);

		removeLocalStorageItem('LIVE_BATTLE');
		if (newTokensArray.length) setLocalStorageItem('LIVE_BATTLE', newTokensArray);
	}
};

export const filterByReference = (arr1, arr2) =>
	arr2
		.map((index) => arr1.find((item) => item.index === index))
		.filter((item) => item !== undefined);

export const getQuestionData = (questionData) => {
	const { id, image_url, list_id, data, answer_locale, question_locale, display_type, word_id } =
		questionData || {};

	return {
		question: data[question_locale],
		answer: data[answer_locale],
		listId: list_id,
		wordImage: image_url,
		id,
		displayType: display_type,
		answerLocale: answer_locale,
		questionLocale: question_locale,
		wordId: word_id,
	};
};

export const goToExerciseStagePage = (history, battleRoomData) => {
	if (!battleRoomData) return;
	const { exercise_stage, exercise, title } = battleRoomData || {};
	const { user_quiz_id, list_ids } = exercise || {};

	if (history)
		historyPush(
			exercise_stage === 'user_quiz'
				? `/quizzes/${user_quiz_id}/${nameInUrlFormat(title)}`
				: `/lists/${list_ids && list_ids[0]}/${nameInUrlFormat(title)}`,
		);
};

export const getFormattedListWords = (exercise) => {
	const { all_configuration: allConfiguration, exercise_type_code, words } = exercise || {};
	const { answer_locale: answerLocale, question_locale: questionLocale } = allConfiguration || {};

	return (
		words &&
		words.map((item) => ({
			display_type: exercise_type_code,
			word_id: item.id,
			correct: null,
			answer_locale: answerLocale,
			question_locale: questionLocale,
			list_id: item.list_id,
			image_url: item.image_url,
			data: item.data,
			multipleChoiceIndices: item.multiple_choice_indices,
			index: item.index,
			time_estimate_in_seconds: item.time_estimate_in_seconds,
		}))
	);
};
